import React from 'react';
import Footer from '../Components/Footer';

const CGU = () => {
  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
    lineHeight: '1.7'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const numberBadge = (number) => (
    <span style={{
      backgroundColor: '#0ea5e9',
      color: 'white',
      borderRadius: '9999px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 600,
      flexShrink: 0
    }}>
      {number}
    </span>
  );

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Conditions Générales d'Utilisation
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            Dernière mise à jour : 31 octobre 2025
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>
            {/* Introduction */}
            <section style={{ 
              marginBottom: '3rem',
              padding: '2rem',
              background: 'rgba(15, 23, 42, 0.5)',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.05)'
            }}>
              <p style={{
                color: '#e2e8f0',
                lineHeight: '1.7',
                fontSize: '1.1rem',
                margin: 0
              }}>
                Bienvenue sur la plateforme AidFoundation. Ces conditions générales d'utilisation (ci-après les "CGU") régissent votre accès et votre utilisation de nos services bancaires en ligne. En accédant ou en utilisant notre plateforme, vous acceptez d'être lié par ces CGU.
              </p>
            </section>

            {/* Article 1 : Définitions */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(1)}
                Définitions
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  <span style={highlightStyle}>« Plateforme »</span> désigne l'application web et mobile AidFoundation permettant l'accès aux services bancaires en ligne.
                </p>
                <p style={paragraphStyle}>
                  <span style={highlightStyle}>« Compte »</span> fait référence à votre espace personnel sécurisé sur la plateforme AidFoundation.
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  <span style={highlightStyle}>« Services »</span> désigne l'ensemble des fonctionnalités bancaires et financières mises à disposition sur la plateforme.
                </p>
              </div>
            </section>

            {/* Article 2 : Objet */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(2)}
                Objet
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Les présentes Conditions Générales d'Utilisation ont pour objet de définir les modalités et conditions dans lesquelles AidFoundation met à disposition sa plateforme bancaire en ligne et les services associés, ainsi que les conditions d'accès et d'utilisation des services par les utilisateurs.
                </p>
              </div>
            </section>

            {/* Article 3 : Accès aux services */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(3)}
                Accès aux services
              </h2>
              <div style={sectionContentStyle}>
                <h3 style={{...paragraphStyle, fontSize: '1.2rem', marginBottom: '0.75rem'}}>3.1 Conditions d'accès</h3>
                <p style={paragraphStyle}>
                  L'accès aux services nécessite la création d'un compte personnel. Vous devez être âgé d'au moins 18 ans et disposer de la pleine capacité juridique pour souscrire à nos services.
                </p>
                
                <h3 style={{...paragraphStyle, fontSize: '1.2rem', margin: '1.5rem 0 0.75rem'}}>3.2 Création du compte</h3>
                <p style={paragraphStyle}>Pour créer un compte, vous devez fournir :</p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Vos nom et prénom complets</li>
                  <li style={listItemStyle}>Votre adresse email valide</li>
                  <li style={listItemStyle}>Un mot de passe sécurisé</li>
                  <li style={listItemStyle}>Vos coordonnées postales</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Une pièce d'identité en cours de validité</li>
                </ul>
              </div>
            </section>

            {/* Article 4 : Utilisation des services */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(4)}
                Utilisation des services
              </h2>
              <div style={sectionContentStyle}>
                <h3 style={{...paragraphStyle, fontSize: '1.2rem', marginBottom: '0.75rem'}}>4.1 Engagements de l'utilisateur</h3>
                <p style={paragraphStyle}>Vous vous engagez à utiliser les services conformément aux présentes CGU et à la réglementation en vigueur. Il vous est notamment interdit de :</p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Utiliser la plateforme à des fins illégales ou frauduleuses</li>
                  <li style={listItemStyle}>Tenter d'accéder à des comptes tiers sans autorisation</li>
                  <li style={listItemStyle}>Perturber le bon fonctionnement des services</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>Transmettre des contenus illicites ou préjudiciables</li>
                </ul>

                <h3 style={{...paragraphStyle, fontSize: '1.2rem', margin: '1.5rem 0 0.75rem'}}>4.2 Disponibilité</h3>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Nous nous efforçons d'assurer un accès continu aux services. Toutefois, des interruptions peuvent survenir pour des raisons de maintenance ou de force majeure.
                </p>
              </div>
            </section>

            {/* Article 5 : Données personnelles */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(5)}
                Données personnelles
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Le traitement de vos données personnelles est régi par notre Politique de Confidentialité, qui est partie intégrante des présentes CGU. En utilisant nos services, vous consentez au traitement de vos données conformément à cette politique.
                </p>
              </div>
            </section>

            {/* Article 6 : Propriété intellectuelle */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(6)}
                Propriété intellectuelle
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  L'ensemble des éléments composant la plateforme (textes, images, logos, logiciels, etc.) sont la propriété exclusive d'AidFoundation ou de ses partenaires. Toute reproduction, représentation ou utilisation non autorisée est strictement interdite.
                </p>
              </div>
            </section>

            {/* Article 7 : Responsabilité */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(7)}
                Responsabilité
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  AidFoundation ne pourra être tenu pour responsable des dommages indirects, des pertes de données ou de bénéfices, résultant de l'utilisation ou de l'impossibilité d'utiliser les services.
                </p>
              </div>
            </section>

            {/* Article 8 : Modification des CGU */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(8)}
                Modification des CGU
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Nous nous réservons le droit de modifier à tout moment les présentes CGU. Les modifications prendront effet dès leur publication sur la plateforme. Il est de votre responsabilité de consulter régulièrement les CGU.
                </p>
              </div>
            </section>

            {/* Article 9 : Droit applicable et juridiction compétente */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(9)}
                Droit applicable et juridiction compétente
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Pour toute question concernant les présentes CGU, vous pouvez nous contacter à l'adresse suivante :{' '}
                  <a href="mailto:contact@aidfoundation.eu" style={{color: '#0ea5e9', textDecoration: 'none'}}>
                    contact@aidfoundation.eu
                  </a>
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CGU;